import React, { useEffect, useState } from "react";
import axios from "axios";
import { makeStyles, withStyles } from "@mui/styles";
import moment from "moment";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
import styled from "styled-components";
import { downloadFile } from "services/ConfigServices";
import UserService from "services/UserService";

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "5ch",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "5ch",
    width: "60ch",
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
}));

const DataResult = styled.div`
  padding: 0.25rem 0.25rem;
  font-size: 14px;
  font-weight: 400;
  opacity: 1;
`;
const DataResultLink = styled.div`
  padding: 0.25rem 0.25rem;
  font-size: 14px;
  font-weight: 400;
  opacity: 1;
  margin-left: auto;
  text-align: right;
  cursor: pointer;
  text-decoration: underline;
`;
const DataContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0.1rem 1rem;
  margin-bottom: 0.6rem;
`;
const DataList = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 0 0.6rem 0;
`;
const Data = styled.div`
font-size: 14px;
font-weight: 600;
opacity: 1;
`;
const DataMargin = styled.div`
font-size: 14px;
font-weight: 500;
opacity: 1;
margin-left: 15px;
`;

function AlertDescriptionDialog(props) {
  const { closeModal, granularity, row,  rowClicked} = props;

  const [startPretty, setStartPretty] = useState("");
  const [endPretty, setEndPretty] = useState("");
  const [criticity, setCriticity] = useState("");
  const [acquitedText, setAcquitedText] = useState("");

  useEffect(() => {
    let acquitedTexttmp = "Non traitée";
    if (row.acquited === "pending") {
      acquitedTexttmp = "En cours de traitement depuis " +
        "le " + moment(row.acquitment.date).format("DD/MM/YYYY") +
        " par " + rowClicked.user;
    }
    else if (row.acquited === "yes") {
      acquitedTexttmp = "Acquitée " +
        "le " + moment(row.acquitment.date).format("DD/MM/YYYY") +
        " par " + rowClicked.user;
    }
    const timeDisplayed = (parame) => {
      let momentParam;
      parame > 0 ? (momentParam = parame) : (momentParam = null);
      return momentParam;
    };

    let startPrettytmp = moment(timeDisplayed(rowClicked.starttime), true).format("DD/MM/YYYY à HH:mm");
    let currentPretty = null;
    if (rowClicked.currenttime)
      currentPretty = moment(timeDisplayed(rowClicked.currenttime), true).format("DD/MM/YYYY à HH:mm");
    let endPrettytmp = "Alerte toujours en cours";
    if (rowClicked.endtime)
    endPrettytmp = moment(timeDisplayed(rowClicked.endtime), true).format("DD/MM/YYYY à HH:mm");
    let criticitytmp = "Information";
    row.criticity == 0 ? (
      criticitytmp = "Information"
    ) : row.criticity == 1 ? (
      criticitytmp = "Avertissement"
    ) : row.criticity == 2 ? (
      criticitytmp = "Important"
    ) : (
      criticitytmp = "Critique"
    );
    setCriticity(criticitytmp);
    setStartPretty(startPrettytmp);
    setEndPretty(endPrettytmp);
    setAcquitedText(acquitedTexttmp);

  }, []);
  const classes = useStyles();

  
  const downloadGED = (fileId, fileName) => async () => {
    axios
      .get(
        downloadFile(fileId, 'import'),
        {
          responseType: "blob",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
  };


  return (
    <>
      <CustomDialogTitle id="customized-dialog-title" onClose={closeModal}>
        {'Détail de l\'alerte "'+row.name+'"'}
      </CustomDialogTitle>
      <DialogContent dividers>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <DataList>
              <DataContainer>
                <Data>{"Catégorie : "}</Data>
                <DataResult>{row.category}</DataResult>
              </DataContainer>
              <DataContainer>
                <Data>{"Criticité : "}</Data>
                <DataResult>{criticity}</DataResult>
              </DataContainer>
              <DataContainer>
                <Data>{"Description\u00A0: "}</Data>
                <DataResult>{rowClicked.description || ""}</DataResult>
              </DataContainer>
              <DataContainer>
                <Data>{"Lieu : "}</Data>
                <DataResult>{row.groupname}</DataResult>
              </DataContainer>
              {row.cost ?
                <DataContainer>
                  <Data>{"Coût total de l'alerte : "}</Data>
                  <DataResult>{row.cost} €</DataResult>
                </DataContainer>
                : <></>}
              <DataContainer>
                <Data>{"Début de l'alerte : "}</Data>
                <DataResult>{startPretty}</DataResult>
              </DataContainer>
              <DataContainer>
                <Data>{"Valeurs"}</Data>
              </DataContainer>
              {
                rowClicked.startvalue ?
                  rowClicked.startvalue.map((valobject, i) => {
                    if (valobject.file) {
                      return (
                        <DataContainer>
                          <DataMargin>{valobject.title}</DataMargin>
                          <DataResultLink onClick={downloadGED(valobject.file.fileid, valobject.file.filename)}>
                            {valobject.file.filename}
                          </DataResultLink>
                        </DataContainer>
                      );
                    }
                    else {
                      return (
                        <DataContainer>
                          <DataMargin>{valobject.title + " : "}</DataMargin>
                          <DataResult>{valobject.val}</DataResult>
                        </DataContainer>
                      );
                    }
                  }) : <></>
              }
              <>
                {
                  rowClicked.currenttime && !rowClicked.endtime ?
                    < DataContainer >
                      <Data>{"Dernière mise à jour : "}</Data>
                      <DataResult>{endPretty}</DataResult>
                    </DataContainer>
                    : <></>
                }
              </>
              <DataContainer>
                <Data>{"Fin de l'alerte : "}</Data>
                <DataResult>{endPretty}</DataResult>
              </DataContainer>
              <DataContainer>
                {
                  rowClicked.endvalue ?
                    <Data>{"Valeurs de fin"}</Data>
                    : rowClicked.currentvalue && !rowClicked.endtime ?
                      <Data>{"Valeurs à jour"}</Data>
                      : <></>
                }
              </DataContainer>
              {
                rowClicked.endvalue ?
                  rowClicked.endvalue.map((valobject, i) => {
                    if (valobject.file) {
                      return (
                        <DataContainer>
                          <DataMargin>{valobject.title}</DataMargin>
                          <DataResultLink onClick={downloadGED(valobject.file.fileid, valobject.file.filename)}>
                            {valobject.file.filename}
                          </DataResultLink>
                        </DataContainer>
                      );
                    }
                    else {
                      return (
                        <DataContainer>
                          <DataMargin>{valobject.title + " : "}</DataMargin>
                          <DataResult>{valobject.val}</DataResult>
                        </DataContainer>
                      );
                    }
                  }) : rowClicked.currentvalue && !rowClicked.endtime ?
                    rowClicked.currentvalue.map((valobject, i) => {
                      if (valobject.file) {
                        return (
                          <DataContainer>
                            <DataMargin>{valobject.title}</DataMargin>
                            <DataResultLink onClick={downloadGED(valobject.file.fileid, valobject.file.filename)}>
                              {valobject.file.filename}
                            </DataResultLink>
                          </DataContainer>
                        );
                      }
                      else {
                        return (
                          <DataContainer>
                            <DataMargin>{valobject.title + " : "}</DataMargin>
                            <DataResult>{valobject.val}</DataResult>
                          </DataContainer>
                        );
                      }
                    })
                    : <></>
              }
              <DataContainer>
                <Data>{"Statut : "}</Data>
                <DataResult>{acquitedText}</DataResult>
              </DataContainer>

            </DataList>
          </GridItem>
        </GridContainer>

      </DialogContent>

    </>
  );
}

export default AlertDescriptionDialog;
